var _style, _g, _rect, _g2, _g3, _g4, _g5, _g6, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdBanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1192 368",
    style: {
      enableBackground: "new 0 0 1192 368"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#000E29;}\n\t.st1{fill:none;stroke:#4E4E4E;}\n\t.st2{fill:none;}\n\t.st3{fill:#2AD2C9;}\n\t.st4{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1193.6,313.9V358L991,41l-12.3-5.3l-12.9-5.9H225.1l-13.5,5.9L200.4,41L0.5,348v-44.1L190.3,11l11.9-5.3 L213.9,1h763.6l12.9,6.5l11.7,6.1L1193.6,313.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1193.6,313.9V358L991,41l-12.3-5.3l-12.9-5.9H225.1l-13.5,5.9L200.4,41L0.5,348v-44.1L190.3,11l11.9-5.3 L213.9,1h763.6l12.9,6.5l11.7,6.1L1193.6,313.9z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1,
    className: "st2",
    width: 1192,
    height: 367
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M23.5,288l0.5-0.8l0.6,0.6l0.1,1.4l-0.5,0.8l-0.6-0.6L23.5,288z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M24.9,289.2l-0.6,0.9l-0.7-0.7l-0.1-1.6l0.6-1l0.7,0.7L24.9,289.2z M24.3,289.8l0.5-0.7l-0.1-1.2l-0.5-0.5 l-0.5,0.7l0.1,1.2L24.3,289.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.1,287.6l0.5-0.8l0.6,0.6l0.1,1.4l-0.5,0.8l-0.6-0.6L31.1,287.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.4,288.8l-0.6,0.9l-0.7-0.7l-0.1-1.6l0.6-0.9l0.7,0.7L32.4,288.8z M31.7,289.4l0.5-0.7l-0.1-1.2l-0.5-0.5 l-0.5,0.7l0.1,1.2L31.7,289.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.9,286.2l0.4-0.6l0.5,0.5l0,1.1l-0.4,0.6l-0.5-0.5L32.9,286.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M33.9,287.2l-0.5,0.8l-0.5-0.5l-0.1-1.3l0.5-0.8l0.5,0.5L33.9,287.2z M33.4,287.6l0.3-0.5l0-0.9l-0.4-0.4 l-0.3,0.5l0,0.9L33.4,287.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.5,277.9l0.4-0.7l0.5,0.5l0.1,1.2l-0.4,0.7l-0.5-0.5L27.5,277.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M28.5,278.9l-0.5,0.8l-0.6-0.6l-0.1-1.4l0.5-0.8l0.6,0.6L28.5,278.9z M28,279.3l0.4-0.6l-0.1-1l-0.4-0.4 l-0.4,0.6l0.1,1L28,279.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M24.3,273.7l0.4-0.7l0.5,0.5l0.1,1.2l-0.4,0.7l-0.5-0.5L24.3,273.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M25.4,274.8l-0.5,0.8l-0.6-0.6l-0.1-1.4l0.5-0.8l0.6,0.6L25.4,274.8z M24.9,275.2l0.4-0.6l-0.1-1l-0.4-0.4 l-0.4,0.6l0.1,1L24.9,275.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M25.5,290l0.2-0.4l0.3,0.3l0,0.6l-0.2,0.4l-0.3-0.3L25.5,290z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26.2,290.6l-0.3,0.5l-0.4-0.3l-0.1-0.8l0.3-0.5l0.4,0.3L26.2,290.6z M25.8,290.7l0.2-0.3l0-0.4l-0.2-0.2 l-0.2,0.3l0,0.4L25.8,290.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26.7,292.7l0.2-0.4l0.3,0.2l0,0.6l-0.2,0.4l-0.3-0.2L26.7,292.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.3,293.2l-0.3,0.5l-0.3-0.3l-0.1-0.8l0.3-0.5l0.3,0.3L27.3,293.2z M27,293.3l0.2-0.2l0-0.4l-0.2-0.2 l-0.2,0.2l0,0.4L27,293.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M28,286.5l0.2-0.4l0.3,0.3l0,0.6l-0.2,0.4l-0.3-0.3L28,286.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M28.7,287.1l-0.3,0.5l-0.3-0.3l0-0.8l0.3-0.5l0.4,0.3L28.7,287.1z M28.3,287.2l0.2-0.3l0-0.4l-0.2-0.2 l-0.2,0.3l0,0.4L28.3,287.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M28.7,283l0.2-0.4l0.3,0.3l0,0.6l-0.2,0.4l-0.3-0.3L28.7,283z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M29.3,283.6l-0.3,0.5l-0.4-0.3l0-0.8l0.3-0.5l0.4,0.3L29.3,283.6z M29,283.7l0.2-0.3l0-0.4l-0.2-0.2l-0.2,0.3 l0,0.4L29,283.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M29.1,280.7l0.2-0.4l0.3,0.3l0,0.6l-0.2,0.4l-0.3-0.3L29.1,280.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M29.7,281.4l-0.3,0.5l-0.4-0.3l0-0.8l0.3-0.5l0.4,0.3L29.7,281.4z M29.4,281.5l0.2-0.3l0-0.4l-0.2-0.2 l-0.2,0.3l0,0.4L29.4,281.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.5,282.7l0.2-0.4l0.3,0.3l0,0.6l-0.2,0.4l-0.3-0.3L30.5,282.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.1,283.3l-0.3,0.5l-0.3-0.3l0-0.8l0.3-0.5l0.3,0.3L31.1,283.3z M30.8,283.4l0.2-0.3l0-0.4l-0.2-0.2 l-0.2,0.3l0,0.4L30.8,283.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.4,284.9l0.2-0.4l0.3,0.3l0,0.6l-0.2,0.4l-0.3-0.3L31.4,284.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32,285.5l-0.3,0.5l-0.3-0.3l0-0.8l0.3-0.5l0.3,0.3L32,285.5z M31.7,285.6l0.2-0.3l0-0.4l-0.2-0.2l-0.2,0.3 l0,0.4L31.7,285.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.8,289.1l0.2-0.4l0.3,0.3l0,0.6l-0.2,0.4l-0.3-0.2L32.8,289.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M33.4,289.7l-0.3,0.5l-0.3-0.3l0-0.8l0.3-0.5l0.3,0.3L33.4,289.7z M33.1,289.8l0.2-0.3l0-0.4l-0.2-0.2 l-0.2,0.3l0,0.4L33.1,289.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30,289.9l0.2-0.4l0.3,0.3l0,0.6l-0.2,0.4l-0.3-0.2L30,289.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.6,290.5l-0.3,0.5l-0.3-0.3l0-0.8l0.3-0.5l0.3,0.3L30.6,290.5z M30.3,290.6l0.2-0.3l0-0.4l-0.2-0.2 l-0.2,0.3l0,0.4L30.3,290.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M28.9,288.9l0.2-0.4l0.3,0.3l0,0.6l-0.2,0.4l-0.3-0.3L28.9,288.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M29.5,289.5l-0.3,0.5l-0.3-0.3l0-0.8l0.3-0.5l0.3,0.3L29.5,289.5z M29.2,289.6l0.2-0.3l0-0.4l-0.2-0.2 l-0.2,0.3l0,0.4L29.2,289.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M23.6,281.9l0.2-0.4l0.3,0.3l0,0.6l-0.2,0.4l-0.3-0.3L23.6,281.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M24.2,282.5l-0.3,0.5l-0.4-0.3l-0.1-0.8l0.3-0.5l0.4,0.3L24.2,282.5z M23.9,282.6l0.2-0.3l0-0.4l-0.2-0.2 l-0.2,0.3l0,0.4L23.9,282.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M22.3,280.5l0.2-0.4l0.3,0.3l0,0.6l-0.2,0.4l-0.3-0.3L22.3,280.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M22.9,281.1l-0.3,0.5l-0.4-0.3l-0.1-0.8l0.3-0.5l0.4,0.4L22.9,281.1z M22.6,281.2l0.2-0.3l0-0.5l-0.2-0.2 l-0.2,0.3l0,0.5L22.6,281.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M29.9,268.6l0.1-0.2l0.2,0.2l0,0.5l-0.1,0.2L30,269L29.9,268.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.3,269.2l-0.2,0.3l-0.3-0.3l-0.1-0.7l0.2-0.3l0.3,0.4L30.3,269.2z M30.1,269.1L30.1,269.1l0-0.3l-0.1-0.1 l0,0l0,0.3L30.1,269.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M28.7,272.7l0.1-0.2l0.2,0.2l0,0.5l-0.1,0.2l-0.2-0.2L28.7,272.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M29.2,273.3l-0.2,0.3l-0.3-0.3l-0.1-0.6l0.2-0.3l0.3,0.3L29.2,273.3z M29,273.2L29,273.2l0-0.3l-0.1-0.1l0,0 l0,0.3L29,273.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M25.6,277.7l0.1-0.2l0.2,0.2l0.1,0.4l-0.1,0.2l-0.2-0.2L25.6,277.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26.1,278.3l-0.2,0.3l-0.3-0.3l-0.1-0.6l0.2-0.3l0.3,0.3L26.1,278.3z M25.9,278.1L25.9,278.1l0-0.3l-0.1-0.1 l0,0l0,0.3L25.9,278.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.6,278l0.1-0.2l0.2,0.2l0,0.4l-0.1,0.2l-0.2-0.2L32.6,278z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M33,278.6l-0.2,0.3l-0.2-0.3l-0.1-0.6l0.2-0.3L33,278L33,278.6z M32.8,278.5L32.8,278.5l0-0.3l-0.1-0.1l0,0 l0,0.3L32.8,278.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M33.9,288.6l0.1-0.2l0.2,0.2l0,0.4l-0.1,0.2l-0.2-0.2L33.9,288.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M34.3,289.2l-0.2,0.3l-0.2-0.3l-0.1-0.6l0.2-0.3l0.2,0.3L34.3,289.2z M34.1,289.1L34.1,289.1l0-0.3l-0.1-0.1 l0,0l0,0.2L34.1,289.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M24,296.8l0.1-0.2l0.2,0.2l0.1,0.4l-0.1,0.2l-0.2-0.2L24,296.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M24.4,297.3l-0.2,0.3l-0.2-0.3l-0.1-0.6l0.2-0.3l0.2,0.3L24.4,297.3z M24.3,297.2L24.3,297.2l0-0.3l-0.1-0.1 l0,0l0,0.2L24.3,297.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M28.3,285l-1.7,2.7l-1.9-1.8l-0.3-4.5l1.7-2.8l2,1.8L28.3,285z M26.6,286.5l1.3-2l-0.2-3.4l-1.5-1.4l-1.3,2.1 l0.2,3.4L26.6,286.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.2,278.4l-1.6,2.5l-1.8-1.7l-0.2-4.3l1.6-2.6l1.8,1.8L32.2,278.4z M30.6,279.8l1.2-1.9l-0.1-3.1l-1.3-1.3 l-1.2,1.9l0.1,3.1L30.6,279.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26.4,295.5l-1.1,1.6l-1.3-1.1l-0.2-2.8l1.1-1.7l1.3,1.2L26.4,295.5z M25.3,296.4l0.8-1.2l-0.1-2.1l-0.9-0.9 l-0.8,1.2l0.1,2.1L25.3,296.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M23.9,286.5l-1.1,1.7l-1.3-1.2l-0.2-3l1.1-1.8l1.3,1.2L23.9,286.5z M22.7,287.4l0.8-1.3l-0.2-2.2l-1-0.9 l-0.8,1.3l0.2,2.2L22.7,287.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M28.3,275.6l-1.1,1.8l-1.3-1.3l-0.2-3.1l1.1-1.8l1.3,1.3L28.3,275.6z M27.1,276.6l0.8-1.3l-0.1-2.3l-1-1 l-0.8,1.4l0.1,2.3L27.1,276.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M33.6,282.7l-0.9,1.3l-1-0.9l-0.1-2.3l0.9-1.4l1,1L33.6,282.7z M32.8,283.3l0.6-0.9l-0.1-1.5l-0.7-0.6 l-0.6,0.9l0.1,1.5L32.8,283.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M25,278.8l-0.9,1.4l-1-1l-0.2-2.4l0.9-1.4l1,1L25,278.8z M24.1,279.4l0.6-0.9l-0.1-1.6l-0.7-0.7l-0.6,0.9 l0.1,1.6L24.1,279.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M23.8,292.5l-0.8,1.3l-1-0.9l-0.2-2.2l0.8-1.3l1,0.9L23.8,292.5z M22.9,293l0.6-0.9l-0.1-1.5l-0.7-0.6 l-0.6,0.9l0.1,1.5L22.9,293z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M28.5,290.8l-0.7,1.1l-0.8-0.8l-0.1-1.9l0.7-1.1l0.8,0.8L28.5,290.8z M27.7,291.2l0.4-0.7l-0.1-1.2l-0.5-0.5 l-0.4,0.7l0.1,1.2L27.7,291.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.9,287l-0.7,1.1l-0.8-0.8l-0.1-1.9l0.7-1.1l0.8,0.8L30.9,287z M30.1,287.4l0.4-0.7l-0.1-1.2L30,285 l-0.4,0.7l0.1,1.2L30.1,287.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M36.1,280.8l-1.5-4.8l1.4-2.2l0.2,0.7l-1,1.6l0.5,1.5l0.9-1.5l0.2,0.6l-0.9,1.5l0.6,2L36.1,280.8z M37.9,278 l-1.5-4.9l1.4-2.2l0.2,0.7l-1.1,1.7l0.4,1.4l1-1.6l0.2,0.6l-1,1.6l0.5,1.5l1.1-1.7l0.2,0.7L37.9,278z M39.8,275l-1.5-5l1.4-2.3 l0.2,0.7l-1.1,1.7l0.4,1.5l1-1.6l0.2,0.6l-1,1.6l0.5,1.5l1.1-1.7l0.2,0.7L39.8,275z M41.8,272.1l-1.5-5l0.8-1.3 c0.7-1.1,1.3-0.8,1.8,0.9l0,0c0.5,1.6,0.3,3.1-0.3,4.2L41.8,272.1z M41.9,270.8l0.4-0.7c0.5-0.7,0.6-1.8,0.2-3l0,0 c-0.3-1.2-0.8-1.4-1.3-0.7l-0.4,0.7L41.9,270.8z M44.9,267.3c-0.5,0.8-1,0.7-1.3-0.1l0,0l0.3-0.5l0,0c0.1,0.4,0.5,0.4,0.8-0.1 c0.3-0.5,0.4-1.1,0.3-1.6l0,0c-0.1-0.4-0.3-0.5-0.6-0.1l-0.3,0.3c-0.5,0.5-0.9,0.3-1.1-0.4l0,0c-0.2-0.9-0.1-2.1,0.4-2.8 c0.5-0.8,1-0.6,1.2,0.1l0,0l-0.3,0.5l0,0c-0.1-0.4-0.4-0.4-0.7,0c-0.3,0.4-0.4,1-0.3,1.5l0,0c0.1,0.4,0.3,0.4,0.6,0.1l0.3-0.3 c0.5-0.5,0.9-0.4,1.1,0.4l0,0C45.6,265.4,45.4,266.5,44.9,267.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M35,271.6c-0.9,1.4-1.9,0.9-2.7-1.4l0,0c-0.7-2.3-0.6-4.8,0.3-6.3c0.7-1.2,1.6-1.1,2.1,0.2l0,0l-0.5,0.8l0,0 c-0.4-0.7-0.9-0.7-1.3,0c-0.6,1-0.6,2.7-0.1,4.4l0,0c0.6,1.7,1.3,2.2,1.9,1.3c0.5-0.8,0.7-2.2,0.3-3.3l-0.1-0.2l-0.8,1.3l-0.3-0.9 l1.3-2.1l0.3,0.9C36.1,268.2,35.9,270.3,35,271.6z M37.1,268.1l-2.3-7.5l2.1-3.4l0.3,1l-1.6,2.6l0.7,2.2l1.5-2.4l0.3,1l-1.5,2.4 l0.7,2.3l1.6-2.5l0.3,1L37.1,268.1z M39.9,263.7l-2.2-7.6l0.5-0.8l3.3,2.9l0-0.1l-1.6-5.7l0.5-0.8l2.2,7.8l-0.5,0.7l-3.3-2.8 l0,0.1l1.6,5.5L39.9,263.7z M43.4,258l-2.2-7.8l0.5-0.9l2.2,7.9L43.4,258z M46.2,253.9c-0.9,1.3-1.7,1-2.2-0.7l-1.4-5.2l0.5-0.9 l1.4,5.2c0.3,1.1,0.8,1.4,1.4,0.6c0.5-0.9,0.6-2.1,0.3-3.3l-1.4-5.2l0.5-0.9l1.4,5.3C47.3,250.5,47.1,252.5,46.2,253.9z  M49.6,248.5c-0.8,1.2-1.5,1.1-1.9-0.2l0-0.1l0.5-0.8l0,0.1c0.2,0.7,0.7,0.6,1.1-0.1c0.4-0.7,0.6-1.7,0.4-2.5l0,0 c-0.2-0.6-0.4-0.7-1-0.2l-0.4,0.4c-0.8,0.8-1.3,0.5-1.6-0.7l0,0c-0.4-1.4-0.1-3.3,0.7-4.5c0.7-1.2,1.5-1,1.8,0.3l0,0.1l-0.5,0.9 l0-0.1c-0.2-0.6-0.6-0.7-1,0c-0.4,0.7-0.6,1.6-0.4,2.4l0,0c0.2,0.6,0.4,0.7,0.9,0.2l0.4-0.4c0.8-0.8,1.3-0.6,1.6,0.6l0,0 C50.7,245.4,50.4,247.2,49.6,248.5z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M83.9,196.5l0.5-0.8l0.6,0.6l0.1,1.4l-0.5,0.8l-0.6-0.6L83.9,196.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M85.2,197.7l-0.6,0.9l-0.7-0.7l-0.1-1.6l0.6-1l0.7,0.7L85.2,197.7z M84.6,198.3l0.5-0.7l-0.1-1.2l-0.5-0.5 l-0.5,0.7l0.1,1.2L84.6,198.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M91.4,196.1l0.5-0.8l0.6,0.6l0.1,1.4l-0.5,0.8l-0.6-0.6L91.4,196.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M92.7,197.3l-0.6,0.9l-0.7-0.7l-0.1-1.6l0.6-0.9l0.7,0.7L92.7,197.3z M92.1,197.9l0.5-0.7l-0.1-1.2l-0.5-0.5 l-0.5,0.7l0.1,1.2L92.1,197.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M93.2,194.7l0.4-0.6l0.5,0.5l0,1.1l-0.4,0.6l-0.5-0.5L93.2,194.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M94.3,195.7l-0.5,0.8l-0.5-0.5l-0.1-1.3l0.5-0.8l0.5,0.5L94.3,195.7z M93.7,196.1l0.3-0.5l0-0.9l-0.4-0.4 l-0.3,0.5l0,0.9L93.7,196.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M87.8,186.3l0.4-0.7l0.5,0.5l0.1,1.2l-0.4,0.7l-0.5-0.5L87.8,186.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M88.9,187.4l-0.5,0.8l-0.6-0.6l-0.1-1.4l0.5-0.8l0.6,0.6L88.9,187.4z M88.3,187.8l0.4-0.6l-0.1-1l-0.4-0.4 l-0.4,0.6l0.1,1L88.3,187.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M84.6,182.2l0.4-0.7l0.5,0.5l0.1,1.2l-0.4,0.7l-0.5-0.5L84.6,182.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M85.7,183.3l-0.5,0.8l-0.6-0.6l-0.1-1.4l0.5-0.8l0.6,0.6L85.7,183.3z M85.2,183.7l0.4-0.6l-0.1-1l-0.4-0.4 l-0.4,0.6l0.1,1L85.2,183.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M85.9,198.5l0.2-0.4l0.3,0.3l0,0.6l-0.2,0.4l-0.3-0.3L85.9,198.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M86.5,199.1l-0.3,0.5l-0.4-0.3l-0.1-0.8l0.3-0.5l0.4,0.3L86.5,199.1z M86.2,199.2l0.2-0.3l0-0.4l-0.2-0.2 l-0.2,0.3l0,0.4L86.2,199.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M87,201.2l0.2-0.4l0.3,0.2l0,0.6l-0.2,0.4l-0.3-0.2L87,201.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M87.6,201.7l-0.3,0.5l-0.3-0.3l-0.1-0.8l0.3-0.5l0.3,0.3L87.6,201.7z M87.3,201.8l0.2-0.2l0-0.4l-0.2-0.2 l-0.2,0.2l0,0.4L87.3,201.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M88.4,195l0.2-0.4l0.3,0.3l0,0.6l-0.2,0.4l-0.3-0.3L88.4,195z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M89,195.6l-0.3,0.5l-0.3-0.3l0-0.8l0.3-0.5l0.4,0.3L89,195.6z M88.7,195.7l0.2-0.3l0-0.4l-0.2-0.2l-0.2,0.3 l0,0.4L88.7,195.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M89,191.5l0.2-0.4l0.3,0.3l0,0.6l-0.2,0.4l-0.3-0.3L89,191.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M89.6,192.1l-0.3,0.5l-0.4-0.3l0-0.8l0.3-0.5l0.4,0.3L89.6,192.1z M89.3,192.2l0.2-0.3l0-0.4l-0.2-0.2 l-0.2,0.3l0,0.4L89.3,192.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M89.4,189.2l0.2-0.4l0.3,0.3l0,0.6l-0.2,0.4l-0.3-0.3L89.4,189.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M90,189.8l-0.3,0.5l-0.4-0.3l0-0.8l0.3-0.5L90,189L90,189.8z M89.7,189.9l0.2-0.3l0-0.4l-0.2-0.2l-0.2,0.3 l0,0.4L89.7,189.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M90.8,191.2l0.2-0.4l0.3,0.3l0,0.6l-0.2,0.4l-0.3-0.3L90.8,191.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M91.4,191.8l-0.3,0.5l-0.3-0.3l0-0.8l0.3-0.5l0.3,0.3L91.4,191.8z M91.1,191.9l0.2-0.3l0-0.4L91,191l-0.2,0.3 l0,0.4L91.1,191.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M91.7,193.4L92,193l0.3,0.3l0,0.6l-0.2,0.4l-0.3-0.3L91.7,193.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M92.3,194l-0.3,0.5l-0.3-0.3l0-0.8l0.3-0.5l0.3,0.3L92.3,194z M92,194.1l0.2-0.3l0-0.4l-0.2-0.2l-0.2,0.3 l0,0.4L92,194.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M93.1,197.6l0.2-0.4l0.3,0.3l0,0.6l-0.2,0.4l-0.3-0.2L93.1,197.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M93.7,198.1l-0.3,0.5l-0.3-0.3l0-0.8l0.3-0.5l0.3,0.3L93.7,198.1z M93.4,198.2l0.2-0.3l0-0.4l-0.2-0.2 l-0.2,0.3l0,0.4L93.4,198.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M90.3,198.4l0.2-0.4l0.3,0.3l0,0.6l-0.2,0.4l-0.3-0.2L90.3,198.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M90.9,199l-0.3,0.5l-0.3-0.3l0-0.8l0.3-0.5l0.3,0.3L90.9,199z M90.6,199.1l0.2-0.3l0-0.4l-0.2-0.2l-0.2,0.3 l0,0.4L90.6,199.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M89.2,197.4l0.2-0.4l0.3,0.3l0,0.6l-0.2,0.4l-0.3-0.3L89.2,197.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M89.8,197.9l-0.3,0.5l-0.3-0.3l0-0.8l0.3-0.5l0.3,0.3L89.8,197.9z M89.5,198l0.2-0.3l0-0.4l-0.2-0.2l-0.2,0.3 l0,0.4L89.5,198z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M83.9,190.4l0.2-0.4l0.3,0.3l0,0.6l-0.2,0.4l-0.3-0.3L83.9,190.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M84.5,191l-0.3,0.5l-0.4-0.3l-0.1-0.8l0.3-0.5l0.4,0.3L84.5,191z M84.2,191.1l0.2-0.3l0-0.4l-0.2-0.2 l-0.2,0.3l0,0.4L84.2,191.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M82.6,189l0.2-0.4l0.3,0.3l0,0.6l-0.2,0.4l-0.3-0.3L82.6,189z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M83.3,189.6l-0.3,0.5l-0.4-0.3l-0.1-0.8l0.3-0.5l0.4,0.4L83.3,189.6z M82.9,189.7l0.2-0.3l0-0.5l-0.2-0.2 l-0.2,0.3l0,0.5L82.9,189.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M90.2,177.1l0.1-0.2l0.2,0.2l0,0.5l-0.1,0.2l-0.2-0.2L90.2,177.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M90.7,177.7l-0.2,0.3l-0.3-0.3l-0.1-0.7l0.2-0.3l0.3,0.4L90.7,177.7z M90.5,177.6L90.5,177.6l0-0.3l-0.1-0.1 l0,0l0,0.3L90.5,177.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M89.1,181.1l0.1-0.2l0.2,0.2l0,0.5l-0.1,0.2l-0.2-0.2L89.1,181.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M89.5,181.8l-0.2,0.3l-0.3-0.3l-0.1-0.6l0.2-0.3l0.3,0.3L89.5,181.8z M89.3,181.6L89.3,181.6l0-0.3l-0.1-0.1 l0,0l0,0.3L89.3,181.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M86,186.1l0.1-0.2l0.2,0.2l0.1,0.4l-0.1,0.2l-0.2-0.2L86,186.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M86.4,186.7l-0.2,0.3l-0.3-0.3l-0.1-0.6l0.2-0.3l0.3,0.3L86.4,186.7z M86.2,186.6L86.2,186.6l0-0.3l-0.1-0.1 l0,0l0,0.3L86.2,186.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M92.9,186.5l0.1-0.2l0.2,0.2l0,0.4l-0.1,0.2L93,187L92.9,186.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M93.3,187.1l-0.2,0.3l-0.2-0.3l-0.1-0.6l0.2-0.3l0.2,0.3L93.3,187.1z M93.1,187L93.1,187l0-0.3l-0.1-0.1l0,0 l0,0.3L93.1,187z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M94.2,197.1l0.1-0.2l0.2,0.2l0,0.4l-0.1,0.2l-0.2-0.2L94.2,197.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M94.6,197.7l-0.2,0.3l-0.2-0.3l-0.1-0.6l0.2-0.3l0.2,0.3L94.6,197.7z M94.4,197.6L94.4,197.6l0-0.3l-0.1-0.1 l0,0l0,0.2L94.4,197.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M84.4,205.3l0.1-0.2l0.2,0.2l0.1,0.4l-0.1,0.2l-0.2-0.2L84.4,205.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M84.8,205.8l-0.2,0.3l-0.2-0.3l-0.1-0.6l0.2-0.3l0.2,0.3L84.8,205.8z M84.6,205.7L84.6,205.7l0-0.3l-0.1-0.1 l0,0l0,0.2L84.6,205.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M88.7,193.4l-1.7,2.7l-1.9-1.8l-0.3-4.5l1.7-2.8l2,1.8L88.7,193.4z M86.9,195l1.3-2l-0.2-3.4l-1.5-1.4 l-1.3,2.1l0.2,3.4L86.9,195z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M92.6,186.9l-1.6,2.5l-1.8-1.7l-0.2-4.3l1.6-2.6l1.8,1.8L92.6,186.9z M90.9,188.3l1.2-1.9l-0.1-3.1l-1.3-1.3 l-1.2,1.9l0.1,3.1L90.9,188.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M86.7,204l-1.1,1.6l-1.3-1.1l-0.2-2.8l1.1-1.7l1.3,1.2L86.7,204z M85.6,204.9l0.8-1.2l-0.1-2.1l-0.9-0.9 l-0.8,1.2l0.1,2.1L85.6,204.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M84.2,195l-1.1,1.7l-1.3-1.2l-0.2-3l1.1-1.8L84,192L84.2,195z M83.1,195.9l0.8-1.3l-0.2-2.2l-1-0.9l-0.8,1.3 l0.2,2.2L83.1,195.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M88.6,184.1l-1.1,1.8l-1.3-1.3l-0.2-3.1l1.1-1.8l1.3,1.3L88.6,184.1z M87.4,185.1l0.8-1.3l-0.1-2.3l-1-1 l-0.8,1.4l0.1,2.3L87.4,185.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M94,191.2l-0.9,1.3l-1-0.9l-0.1-2.3l0.9-1.4l1,1L94,191.2z M93.1,191.8l0.6-0.9l-0.1-1.5l-0.7-0.6l-0.6,0.9 l0.1,1.5L93.1,191.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M85.3,187.3l-0.9,1.4l-1-1l-0.2-2.4l0.9-1.4l1,1L85.3,187.3z M84.4,187.9L85,187l-0.1-1.6l-0.7-0.7l-0.6,0.9 l0.1,1.6L84.4,187.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M84.1,201l-0.8,1.3l-1-0.9l-0.2-2.2l0.8-1.3l1,0.9L84.1,201z M83.2,201.5l0.6-0.9l-0.1-1.5l-0.7-0.6l-0.6,0.9 l0.1,1.5L83.2,201.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M88.8,199.3l-0.7,1.1l-0.8-0.8l-0.1-1.9l0.7-1.1l0.8,0.8L88.8,199.3z M88.1,199.7l0.4-0.7l-0.1-1.2l-0.5-0.5 l-0.4,0.7l0.1,1.2L88.1,199.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M91.2,195.5l-0.7,1.1l-0.8-0.8l-0.1-1.9l0.7-1.1l0.8,0.8L91.2,195.5z M90.5,195.9l0.4-0.7l-0.1-1.2l-0.5-0.5 l-0.4,0.7l0.1,1.2L90.5,195.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M96.5,189.3l-1.5-4.8l1.4-2.2l0.2,0.7l-1,1.6l0.5,1.5l0.9-1.5l0.2,0.6l-0.9,1.5l0.6,2L96.5,189.3z  M98.3,186.5l-1.5-4.9l1.4-2.2l0.2,0.7l-1.1,1.7l0.4,1.4l1-1.6l0.2,0.6l-1,1.6l0.5,1.5l1.1-1.7l0.2,0.7L98.3,186.5z M100.2,183.5 l-1.5-5l1.4-2.3l0.2,0.7l-1.1,1.7l0.4,1.5l1-1.6l0.2,0.6l-1,1.6l0.5,1.5l1.1-1.7l0.2,0.7L100.2,183.5z M102.1,180.5l-1.5-5 l0.8-1.3c0.7-1.1,1.3-0.8,1.8,0.9l0,0c0.5,1.6,0.3,3.1-0.3,4.2L102.1,180.5z M102.2,179.3l0.4-0.7c0.5-0.7,0.6-1.8,0.2-3l0,0 c-0.3-1.2-0.8-1.4-1.3-0.7l-0.4,0.7L102.2,179.3z M105.2,175.8c-0.5,0.8-1,0.7-1.3-0.1l0,0l0.3-0.5l0,0c0.1,0.4,0.5,0.4,0.8-0.1 c0.3-0.5,0.4-1.1,0.3-1.6l0,0c-0.1-0.4-0.3-0.5-0.6-0.1l-0.3,0.3c-0.5,0.5-0.9,0.3-1.1-0.4l0,0c-0.2-0.9-0.1-2.1,0.4-2.8 c0.5-0.8,1-0.6,1.2,0.1l0,0l-0.3,0.5l0,0c-0.1-0.4-0.4-0.4-0.7,0c-0.3,0.4-0.4,1-0.3,1.5l0,0c0.1,0.4,0.3,0.4,0.6,0.1l0.3-0.3 c0.5-0.5,0.9-0.4,1.1,0.4l0,0C105.9,173.8,105.8,175,105.2,175.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M95.4,180.1c-0.9,1.4-1.9,0.9-2.7-1.4l0,0c-0.7-2.3-0.6-4.8,0.3-6.3c0.7-1.2,1.6-1.1,2.1,0.2l0,0l-0.5,0.8 l0,0c-0.4-0.7-0.9-0.7-1.3,0c-0.6,1-0.6,2.7-0.1,4.4l0,0c0.6,1.7,1.3,2.2,1.9,1.3c0.5-0.8,0.7-2.2,0.3-3.3l-0.1-0.2l-0.8,1.3 l-0.3-0.9l1.3-2.1l0.3,0.9C96.4,176.7,96.2,178.8,95.4,180.1z M97.4,176.6l-2.3-7.5l2.1-3.4l0.3,1l-1.6,2.6l0.7,2.2l1.5-2.4l0.3,1 l-1.5,2.4l0.7,2.3l1.6-2.5l0.3,1L97.4,176.6z M100.2,172.2l-2.2-7.6l0.5-0.8l3.3,2.9l0-0.1l-1.6-5.7l0.5-0.8l2.2,7.8l-0.5,0.7 l-3.3-2.8l0,0.1l1.6,5.5L100.2,172.2z M103.7,166.5l-2.2-7.8l0.5-0.9l2.2,7.9L103.7,166.5z M106.5,162.4c-0.9,1.3-1.7,1-2.2-0.7 l-1.4-5.2l0.5-0.9l1.4,5.2c0.3,1.1,0.8,1.4,1.4,0.6c0.5-0.9,0.6-2.1,0.3-3.3l-1.4-5.2l0.5-0.9l1.4,5.3 C107.6,159,107.4,161,106.5,162.4z M109.9,157c-0.8,1.2-1.5,1.1-1.9-0.2l0-0.1l0.5-0.8l0,0.1c0.2,0.7,0.7,0.6,1.1-0.1 c0.4-0.7,0.6-1.7,0.4-2.5l0,0c-0.2-0.6-0.4-0.7-1-0.2l-0.4,0.4c-0.8,0.8-1.3,0.5-1.6-0.7l0,0c-0.4-1.4-0.1-3.3,0.7-4.5 c0.7-1.2,1.5-1,1.8,0.3l0,0.1l-0.5,0.9l0-0.1c-0.2-0.6-0.6-0.7-1,0c-0.4,0.7-0.6,1.6-0.4,2.4l0,0c0.2,0.6,0.4,0.7,0.9,0.2l0.4-0.4 c0.8-0.8,1.3-0.6,1.6,0.6l0,0C111,153.9,110.7,155.7,109.9,157z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M140.9,108.4l0.5-0.8l0.6,0.6l0.1,1.4l-0.5,0.8l-0.6-0.6L140.9,108.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M142.2,109.6l-0.6,0.9l-0.7-0.7l-0.1-1.6l0.6-1l0.7,0.7L142.2,109.6z M141.6,110.2l0.5-0.7l-0.1-1.2l-0.5-0.5 l-0.5,0.7l0.1,1.2L141.6,110.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M148.4,108l0.5-0.8l0.6,0.6l0.1,1.4l-0.5,0.8l-0.6-0.6L148.4,108z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M149.7,109.2l-0.6,0.9l-0.7-0.7l-0.1-1.6l0.6-0.9l0.7,0.7L149.7,109.2z M149.1,109.8l0.5-0.7l-0.1-1.2 l-0.5-0.5l-0.5,0.7l0.1,1.2L149.1,109.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M150.3,106.6l0.4-0.6l0.5,0.5l0,1.1l-0.4,0.6l-0.5-0.5L150.3,106.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M151.3,107.6l-0.5,0.8l-0.5-0.5l-0.1-1.3l0.5-0.8l0.5,0.5L151.3,107.6z M150.8,108l0.3-0.5l0-0.9l-0.4-0.4 l-0.3,0.5l0,0.9L150.8,108z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M144.8,98.3l0.4-0.7l0.5,0.5l0.1,1.2l-0.4,0.7l-0.5-0.5L144.8,98.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M145.9,99.3l-0.5,0.8l-0.6-0.6l-0.1-1.4l0.5-0.8l0.6,0.6L145.9,99.3z M145.4,99.7l0.4-0.6l-0.1-1l-0.4-0.4 l-0.4,0.6l0.1,1L145.4,99.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M141.7,94.1l0.4-0.7l0.5,0.5l0.1,1.2l-0.4,0.7l-0.5-0.5L141.7,94.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M142.8,95.2l-0.5,0.8l-0.6-0.6l-0.1-1.4l0.5-0.8l0.6,0.6L142.8,95.2z M142.3,95.6l0.4-0.6l-0.1-1l-0.4-0.4 l-0.4,0.6l0.1,1L142.3,95.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M142.9,110.4l0.2-0.4l0.3,0.3l0,0.6l-0.2,0.4l-0.3-0.3L142.9,110.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M143.5,111l-0.3,0.5l-0.4-0.3l-0.1-0.8l0.3-0.5l0.4,0.3L143.5,111z M143.2,111.1l0.2-0.3l0-0.4l-0.2-0.2 l-0.2,0.3l0,0.4L143.2,111.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M144,113.1l0.2-0.4l0.3,0.2l0,0.6l-0.2,0.4l-0.3-0.2L144,113.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M144.7,113.6l-0.3,0.5l-0.3-0.3L144,113l0.3-0.5l0.3,0.3L144.7,113.6z M144.3,113.7l0.2-0.2l0-0.4l-0.2-0.2 l-0.2,0.2l0,0.4L144.3,113.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M145.4,106.9l0.2-0.4l0.3,0.3l0,0.6l-0.2,0.4l-0.3-0.3L145.4,106.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M146,107.5l-0.3,0.5l-0.3-0.3l0-0.8l0.3-0.5l0.4,0.3L146,107.5z M145.7,107.6l0.2-0.3l0-0.4l-0.2-0.2 l-0.2,0.3l0,0.4L145.7,107.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M146.1,103.4l0.2-0.4l0.3,0.3l0,0.6l-0.2,0.4l-0.3-0.3L146.1,103.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M146.7,104l-0.3,0.5l-0.4-0.3l0-0.8l0.3-0.5l0.4,0.3L146.7,104z M146.4,104.1l0.2-0.3l0-0.4l-0.2-0.2 l-0.2,0.3l0,0.4L146.4,104.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M146.4,101.1l0.2-0.4l0.3,0.3l0,0.6l-0.2,0.4l-0.3-0.3L146.4,101.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M147.1,101.8l-0.3,0.5l-0.4-0.3l0-0.8l0.3-0.5l0.4,0.3L147.1,101.8z M146.7,101.9l0.2-0.3l0-0.4l-0.2-0.2 l-0.2,0.3l0,0.4L146.7,101.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M147.8,103.1l0.2-0.4l0.3,0.3l0,0.6l-0.2,0.4l-0.3-0.3L147.8,103.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M148.4,103.7l-0.3,0.5l-0.3-0.3l0-0.8l0.3-0.5l0.3,0.3L148.4,103.7z M148.1,103.8l0.2-0.3l0-0.4l-0.2-0.2 l-0.2,0.3l0,0.4L148.1,103.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M148.8,105.3l0.2-0.4l0.3,0.3l0,0.6l-0.2,0.4l-0.3-0.3L148.8,105.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M149.4,105.9l-0.3,0.5l-0.3-0.3l0-0.8l0.3-0.5l0.3,0.3L149.4,105.9z M149.1,106l0.2-0.3l0-0.4l-0.2-0.2 l-0.2,0.3l0,0.4L149.1,106z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M150.2,109.5l0.2-0.4l0.3,0.3l0,0.6l-0.2,0.4l-0.3-0.2L150.2,109.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M150.8,110.1l-0.3,0.5l-0.3-0.3l0-0.8l0.3-0.5l0.3,0.3L150.8,110.1z M150.5,110.2l0.2-0.3l0-0.4l-0.2-0.2 l-0.2,0.3l0,0.4L150.5,110.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M147.3,110.3l0.2-0.4l0.3,0.3l0,0.6l-0.2,0.4l-0.3-0.2L147.3,110.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M147.9,110.9l-0.3,0.5l-0.3-0.3l0-0.8l0.3-0.5l0.3,0.3L147.9,110.9z M147.6,111l0.2-0.3l0-0.4l-0.2-0.2 l-0.2,0.3l0,0.4L147.6,111z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M146.2,109.3l0.2-0.4l0.3,0.3l0,0.6l-0.2,0.4l-0.3-0.3L146.2,109.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M146.8,109.8l-0.3,0.5l-0.3-0.3l0-0.8l0.3-0.5l0.3,0.3L146.8,109.8z M146.5,109.9l0.2-0.3l0-0.4l-0.2-0.2 l-0.2,0.3l0,0.4L146.5,109.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M140.9,102.3l0.2-0.4l0.3,0.3l0,0.6l-0.2,0.4l-0.3-0.3L140.9,102.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M141.6,102.9l-0.3,0.5l-0.4-0.3l-0.1-0.8l0.3-0.5l0.4,0.3L141.6,102.9z M141.2,103l0.2-0.3l0-0.4l-0.2-0.2 l-0.2,0.3l0,0.4L141.2,103z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M139.7,100.9l0.2-0.4l0.3,0.3l0,0.6l-0.2,0.4l-0.3-0.3L139.7,100.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M140.3,101.5L140,102l-0.4-0.3l-0.1-0.8l0.3-0.5l0.4,0.4L140.3,101.5z M140,101.6l0.2-0.3l0-0.5l-0.2-0.2 l-0.2,0.3l0,0.5L140,101.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M147.3,89l0.1-0.2l0.2,0.2l0,0.5l-0.1,0.2l-0.2-0.2L147.3,89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M147.7,89.6l-0.2,0.3l-0.3-0.3l-0.1-0.7l0.2-0.3l0.3,0.4L147.7,89.6z M147.5,89.5L147.5,89.5l0-0.3l-0.1-0.1 l0,0l0,0.3L147.5,89.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M146.1,93.1l0.1-0.2l0.2,0.2l0,0.5l-0.1,0.2l-0.2-0.2L146.1,93.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M146.5,93.7l-0.2,0.3l-0.3-0.3L146,93l0.2-0.3l0.3,0.3L146.5,93.7z M146.3,93.5L146.3,93.5l0-0.3l-0.1-0.1 l0,0l0,0.3L146.3,93.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M143,98.1l0.1-0.2l0.2,0.2l0.1,0.4l-0.1,0.2l-0.2-0.2L143,98.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M143.4,98.6l-0.2,0.3l-0.3-0.3l-0.1-0.6l0.2-0.3l0.3,0.3L143.4,98.6z M143.2,98.5L143.2,98.5l0-0.3l-0.1-0.1 l0,0l0,0.3L143.2,98.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M150,98.4l0.1-0.2l0.2,0.2l0,0.4l-0.1,0.2l-0.2-0.2L150,98.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M150.4,99l-0.2,0.3l-0.2-0.3l-0.1-0.6l0.2-0.3l0.2,0.3L150.4,99z M150.2,98.9L150.2,98.9l0-0.3l-0.1-0.1l0,0 l0,0.3L150.2,98.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M151.2,109l0.1-0.2l0.2,0.2l0,0.4l-0.1,0.2l-0.2-0.2L151.2,109z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M151.6,109.6l-0.2,0.3l-0.2-0.3l-0.1-0.6l0.2-0.3l0.2,0.3L151.6,109.6z M151.4,109.5L151.4,109.5l0-0.3 l-0.1-0.1l0,0l0,0.2L151.4,109.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M141.4,117.2l0.1-0.2l0.2,0.2l0.1,0.4l-0.1,0.2l-0.2-0.2L141.4,117.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M141.8,117.7l-0.2,0.3l-0.2-0.3l-0.1-0.6l0.2-0.3l0.2,0.3L141.8,117.7z M141.6,117.6L141.6,117.6l0-0.3 l-0.1-0.1l0,0l0,0.2L141.6,117.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M145.7,105.4L144,108l-1.9-1.8l-0.3-4.5l1.7-2.8l2,1.8L145.7,105.4z M143.9,106.9l1.3-2l-0.2-3.4l-1.5-1.4 l-1.3,2.1l0.2,3.4L143.9,106.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M149.6,98.8l-1.6,2.5l-1.8-1.7l-0.2-4.3l1.6-2.6l1.8,1.8L149.6,98.8z M147.9,100.2l1.2-1.9l-0.1-3.1l-1.3-1.3 l-1.2,1.9l0.1,3.1L147.9,100.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M143.8,115.9l-1.1,1.6l-1.3-1.1l-0.2-2.8l1.1-1.7l1.3,1.2L143.8,115.9z M142.7,116.8l0.8-1.2l-0.1-2.1 l-0.9-0.9l-0.8,1.2l0.1,2.1L142.7,116.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M141.2,106.9l-1.1,1.7l-1.3-1.2l-0.2-3l1.1-1.8l1.3,1.2L141.2,106.9z M140.1,107.8l0.8-1.3l-0.2-2.2l-1-0.9 l-0.8,1.3l0.2,2.2L140.1,107.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M145.6,96l-1.1,1.8l-1.3-1.3l-0.2-3.1l1.1-1.8l1.3,1.3L145.6,96z M144.5,97l0.8-1.3l-0.1-2.3l-1-1l-0.8,1.4 l0.1,2.3L144.5,97z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M151,103.1l-0.9,1.3l-1-0.9l-0.1-2.3l0.9-1.4l1,1L151,103.1z M150.1,103.7l0.6-0.9l-0.1-1.5l-0.7-0.6 l-0.6,0.9l0.1,1.5L150.1,103.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M142.3,99.2l-0.9,1.4l-1-1l-0.2-2.4l0.9-1.4l1,1L142.3,99.2z M141.4,99.8l0.6-0.9l-0.1-1.6l-0.7-0.7l-0.6,0.9 l0.1,1.6L141.4,99.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M141.2,112.9l-0.8,1.3l-1-0.9l-0.2-2.2l0.8-1.3l1,0.9L141.2,112.9z M140.3,113.4l0.6-0.9l-0.1-1.5l-0.7-0.6 l-0.6,0.9l0.1,1.5L140.3,113.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M145.9,111.2l-0.7,1.1l-0.8-0.8l-0.1-1.9l0.7-1.1l0.8,0.8L145.9,111.2z M145.1,111.6l0.4-0.7l-0.1-1.2 l-0.5-0.5l-0.4,0.7l0.1,1.2L145.1,111.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M148.3,107.4l-0.7,1.1l-0.8-0.8l-0.1-1.9l0.7-1.1l0.8,0.8L148.3,107.4z M147.5,107.8l0.4-0.7l-0.1-1.2 l-0.5-0.5l-0.4,0.7l0.1,1.2L147.5,107.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M153.5,101.2l-1.5-4.8l1.4-2.2l0.2,0.7l-1,1.6L153,98l0.9-1.5l0.2,0.6l-0.9,1.5l0.6,2L153.5,101.2z  M155.3,98.4l-1.5-4.9l1.4-2.2l0.2,0.7l-1.1,1.7l0.4,1.4l1-1.6l0.2,0.6l-1,1.6l0.5,1.5l1.1-1.7l0.2,0.7L155.3,98.4z M157.2,95.4 l-1.5-5l1.4-2.3l0.2,0.7l-1.1,1.7l0.4,1.5l1-1.6l0.2,0.6l-1,1.6l0.5,1.5l1.1-1.7l0.2,0.7L157.2,95.4z M159.1,92.4l-1.5-5l0.8-1.3 c0.7-1.1,1.3-0.8,1.8,0.9l0,0c0.5,1.6,0.3,3.1-0.3,4.2L159.1,92.4z M159.3,91.2l0.4-0.7c0.5-0.7,0.6-1.8,0.2-3l0,0 c-0.3-1.2-0.8-1.4-1.3-0.7l-0.4,0.7L159.3,91.2z M162.3,87.7c-0.5,0.8-1,0.7-1.3-0.1l0,0l0.3-0.5l0,0c0.1,0.4,0.5,0.4,0.8-0.1 c0.3-0.5,0.4-1.1,0.3-1.6l0,0c-0.1-0.4-0.3-0.5-0.6-0.1l-0.3,0.3c-0.5,0.5-0.9,0.3-1.1-0.4l0,0c-0.2-0.9-0.1-2.1,0.4-2.8 c0.5-0.8,1-0.6,1.2,0.1l0,0l-0.3,0.5l0,0c-0.1-0.4-0.4-0.4-0.7,0c-0.3,0.4-0.4,1-0.3,1.5l0,0c0.1,0.4,0.3,0.4,0.6,0.1l0.3-0.3 c0.5-0.5,0.9-0.4,1.1,0.4l0,0C163,85.7,162.8,86.9,162.3,87.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M152.4,92c-0.9,1.4-1.9,0.9-2.7-1.4l0,0c-0.7-2.3-0.6-4.8,0.3-6.3c0.7-1.2,1.6-1.1,2.1,0.2l0,0l-0.5,0.8l0,0 c-0.4-0.7-0.9-0.7-1.3,0c-0.6,1-0.6,2.7-0.1,4.4l0,0c0.6,1.7,1.3,2.2,1.9,1.3c0.5-0.8,0.7-2.2,0.3-3.3l-0.1-0.2l-0.8,1.3l-0.3-0.9 l1.3-2.1l0.3,0.9C153.4,88.6,153.2,90.7,152.4,92z M154.4,88.5l-2.3-7.5l2.1-3.4l0.3,1l-1.6,2.6l0.7,2.2l1.5-2.4l0.3,1l-1.5,2.4 l0.7,2.3l1.6-2.5l0.3,1L154.4,88.5z M157.2,84.1l-2.2-7.6l0.5-0.8l3.3,2.9l0-0.1l-1.6-5.7l0.5-0.8l2.2,7.8l-0.5,0.7l-3.3-2.8 l0,0.1l1.6,5.5L157.2,84.1z M160.8,78.4l-2.2-7.8l0.5-0.9l2.2,7.9L160.8,78.4z M163.6,74.3c-0.9,1.3-1.7,1-2.2-0.7l-1.4-5.2 l0.5-0.9l1.4,5.2c0.3,1.1,0.8,1.4,1.4,0.6c0.5-0.9,0.6-2.1,0.3-3.3l-1.4-5.2l0.5-0.9l1.4,5.3C164.6,70.9,164.4,72.9,163.6,74.3z  M167,68.9c-0.8,1.2-1.5,1.1-1.9-0.2l0-0.1l0.5-0.8l0,0.1c0.2,0.7,0.7,0.6,1.1-0.1c0.4-0.7,0.6-1.7,0.4-2.5l0,0 c-0.2-0.6-0.4-0.7-1-0.2l-0.4,0.4c-0.8,0.8-1.3,0.5-1.6-0.7l0,0c-0.4-1.4-0.1-3.3,0.7-4.5c0.7-1.2,1.5-1,1.8,0.3l0,0.1l-0.5,0.9 l0-0.1c-0.2-0.6-0.6-0.7-1,0c-0.4,0.7-0.6,1.6-0.4,2.4l0,0c0.2,0.6,0.4,0.7,0.9,0.2l0.4-0.4c0.8-0.8,1.3-0.6,1.6,0.6l0,0 C168.1,65.8,167.8,67.6,167,68.9z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1144,256l0.5,0.9l0.1,1.9l-0.4,1l-0.5-0.9l-0.1-1.9L1144,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1144.2,260l-0.6-1l-0.1-2.1l0.5-1.1l0.6,1l0.1,2.1L1144.2,260z M1143.7,258.7l0.5,0.8l0.4-0.8l-0.1-1.6 l-0.5-0.8l-0.4,0.8L1143.7,258.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1147.7,274.5l0.5,0.9l0.1,1.8l-0.4,1l-0.5-0.9l-0.1-1.8L1147.7,274.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1148,278.4l-0.6-1l-0.1-2.1l0.5-1.1l0.6,1l0.1,2.1L1148,278.4z M1147.5,277.1l0.5,0.8l0.4-0.8l-0.1-1.6 l-0.5-0.8l-0.4,0.8L1147.5,277.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1149,278.3l0.4,0.7l0.1,1.4l-0.3,0.7l-0.4-0.7l-0.1-1.4L1149,278.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1149.2,281.4l-0.5-0.8l-0.1-1.7l0.4-0.9l0.5,0.8l0.1,1.7L1149.2,281.4z M1148.9,280.4l0.3,0.6l0.3-0.6 l-0.1-1.2l-0.3-0.6l-0.3,0.6L1148.9,280.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1149,260.5l0.4,0.7l0.1,1.4l-0.3,0.8l-0.4-0.7l-0.1-1.4L1149,260.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1149.2,263.6l-0.5-0.8l-0.1-1.7l0.4-0.9l0.5,0.8l0.1,1.7L1149.2,263.6z M1148.8,262.6l0.3,0.6l0.3-0.6 l-0.1-1.2l-0.3-0.6l-0.3,0.6L1148.8,262.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1148.8,251l0.4,0.7l0.1,1.4l-0.3,0.8l-0.4-0.7l-0.1-1.4L1148.8,251z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1149,254.1l-0.5-0.8l-0.1-1.7l0.4-0.9l0.5,0.8l0.1,1.7L1149,254.1z M1148.6,253l0.3,0.6l0.3-0.6l-0.1-1.2 l-0.3-0.6l-0.3,0.6L1148.6,253z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1144.3,262.1l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1144.3,262.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1144.4,263.9l-0.3-0.5l-0.1-1l0.2-0.6l0.3,0.5l0.1,1L1144.4,263.9z M1144.2,263.2l0.2,0.3l0.1-0.3l0-0.6 l-0.2-0.3l-0.1,0.3L1144.2,263.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1144,266.3l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1144,266.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1144.1,268.1l-0.3-0.5l-0.1-1l0.2-0.5l0.3,0.5l0.1,1L1144.1,268.1z M1143.9,267.4l0.2,0.3l0.1-0.3l0-0.6 l-0.2-0.3l-0.1,0.3L1143.9,267.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1146.6,266.4l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1146.6,266.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1146.7,268.2l-0.3-0.5l-0.1-1l0.2-0.5l0.3,0.5l0.1,1L1146.7,268.2z M1146.5,267.5l0.2,0.3l0.1-0.3l0-0.6 l-0.2-0.3l-0.1,0.3L1146.5,267.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1148,266.1l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1148,266.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1148.1,268l-0.3-0.5l-0.1-1l0.2-0.5l0.3,0.5l0.1,1L1148.1,268z M1147.9,267.2l0.2,0.3l0.1-0.3l0-0.6 l-0.2-0.3l-0.1,0.3L1147.9,267.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1148.9,265.9l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1148.9,265.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1149,267.7l-0.3-0.5l-0.1-1l0.2-0.5l0.3,0.5l0.1,1L1149,267.7z M1148.8,267l0.2,0.3l0.1-0.3l0-0.6l-0.2-0.3 l-0.1,0.3L1148.8,267z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1149,270.3l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1149,270.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1149.1,272.2l-0.3-0.5l-0.1-1l0.2-0.5l0.3,0.5l0.1,1L1149.1,272.2z M1148.9,271.4l0.2,0.3l0.1-0.3l0-0.6 l-0.2-0.3l-0.1,0.3L1148.9,271.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1148.7,273.8l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1148.7,273.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1148.8,275.7l-0.3-0.5l-0.1-1l0.2-0.5l0.3,0.5l0.1,1L1148.8,275.7z M1148.6,274.9l0.2,0.3l0.1-0.3l0-0.6 l-0.2-0.3l-0.1,0.3L1148.6,274.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1148.1,279.7l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1148.1,279.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1148.2,281.5l-0.3-0.5l-0.1-1l0.2-0.5l0.3,0.5l0.1,1L1148.2,281.5z M1148,280.8l0.2,0.3l0.1-0.3l0-0.6 l-0.2-0.3l-0.1,0.3L1148,280.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1146.5,273l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1146.5,273z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1146.6,274.9l-0.3-0.5l-0.1-1l0.2-0.5l0.3,0.5l0.1,1L1146.6,274.9z M1146.4,274.1l0.2,0.3l0.1-0.3l0-0.6 l-0.2-0.3l-0.1,0.3L1146.4,274.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1146.3,269.7l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1146.3,269.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1146.4,271.5l-0.3-0.5l-0.1-1l0.2-0.5l0.3,0.5l0.1,1L1146.4,271.5z M1146.2,270.8l0.2,0.3l0.1-0.3l0-0.6 l-0.2-0.3l-0.1,0.3L1146.2,270.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1145.9,253.1l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1145.9,253.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1146.1,254.9l-0.3-0.5l-0.1-1l0.2-0.6l0.3,0.5l0.1,1L1146.1,254.9z M1145.9,254.2l0.2,0.3l0.1-0.3l0-0.6 l-0.2-0.3l-0.1,0.3L1145.9,254.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1145.8,249.3l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1145.8,249.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1145.9,251.2l-0.3-0.5l-0.1-1l0.2-0.6l0.3,0.5l0.1,1L1145.9,251.2z M1145.7,250.4l0.2,0.3l0.1-0.3l0-0.6 l-0.2-0.3l-0.1,0.3L1145.7,250.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1152.9,261.7l0.1,0.2l0,0.6l-0.1,0.3l-0.1-0.2l0-0.6L1152.9,261.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1152.9,263l-0.2-0.3l0-0.8l0.2-0.5l0.2,0.3l0,0.8L1152.9,263z M1152.8,262.5L1152.8,262.5l0.1-0.2l0-0.3l0,0 l-0.1,0.2L1152.8,262.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1151.1,260.9l0.1,0.2l0,0.6l-0.1,0.3l-0.1-0.2l0-0.6L1151.1,260.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1151.2,262.3l-0.2-0.3l0-0.8l0.2-0.5l0.2,0.3l0,0.8L1151.2,262.3z M1151.1,261.7L1151.1,261.7l0.1-0.2l0-0.3 l0,0l-0.1,0.2L1151.1,261.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1148.2,256l0.1,0.2l0,0.6l-0.1,0.3l-0.1-0.2l0-0.6L1148.2,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1148.2,257.3l-0.2-0.3l0-0.8l0.2-0.5l0.2,0.3l0,0.8L1148.2,257.3z M1148.2,256.8L1148.2,256.8l0.1-0.2l0-0.3 l0,0l-0.1,0.2L1148.2,256.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1151.4,273l0.1,0.2l0,0.6l-0.1,0.3l-0.1-0.2l0-0.6L1151.4,273z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1151.4,274.4l-0.2-0.3l0-0.8l0.2-0.5l0.2,0.3l0,0.8L1151.4,274.4z M1151.3,273.8L1151.3,273.8l0.1-0.2l0-0.3 l0,0l-0.1,0.2L1151.3,273.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1148.7,282.1l0.1,0.2l0,0.6l-0.1,0.3l-0.1-0.2l0-0.6L1148.7,282.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1148.8,283.4l-0.2-0.3l0-0.8l0.2-0.5l0.2,0.3l0,0.8L1148.8,283.4z M1148.7,282.8L1148.7,282.8l0.1-0.2l0-0.3 l0,0l-0.1,0.2L1148.7,282.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1141.3,261.8l0.1,0.2l0,0.6l-0.1,0.3l-0.1-0.2l0-0.6L1141.3,261.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1141.4,263.2l-0.2-0.3l0-0.8l0.2-0.5l0.2,0.3l0,0.8L1141.4,263.2z M1141.3,262.6L1141.3,262.6l0.1-0.2l0-0.3 l0,0l-0.1,0.2L1141.3,262.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1147.2,266.3l-1.6-2.8l-0.4-5.7l1.3-2.9l1.6,2.8l0.4,5.7L1147.2,266.3z M1145.9,262.7l1.2,2.1l1-2.2 l-0.3-4.2l-1.2-2.1l-1,2.2L1145.9,262.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1151.1,272.4l-1.5-2.6l-0.3-5.3l1.2-2.7l1.5,2.6l0.3,5.3L1151.1,272.4z M1149.9,269l1.1,1.9l0.9-1.9 l-0.2-3.8l-1.1-1.9l-0.9,2L1149.9,269z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1142.9,267.1l-1.1-1.8l-0.2-3.8l0.8-2l1.1,1.8l0.2,3.8L1142.9,267.1z M1142.1,264.8l0.8,1.3l0.6-1.5 l-0.2-2.8l-0.8-1.3l-0.6,1.5L1142.1,264.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1144.6,256.1l-1.1-1.8l-0.2-3.8l0.8-2l1.1,1.8l0.2,3.8L1144.6,256.1z M1143.8,253.8l0.8,1.3l0.6-1.5 l-0.2-2.8l-0.8-1.3l-0.6,1.5L1143.8,253.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1150.1,261.3l-1.1-1.8l-0.2-3.8l0.8-2l1.1,1.8l0.2,3.8L1150.1,261.3z M1149.2,259l0.8,1.3l0.6-1.5l-0.2-2.8 l-0.8-1.3l-0.6,1.5L1149.2,259z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1150.5,278.1l-0.8-1.4l-0.2-2.9l0.6-1.5l0.8,1.4l0.2,2.9L1150.5,278.1z M1149.9,276.3l0.6,0.9l0.4-1l-0.1-2 l-0.6-0.9l-0.4,1L1149.9,276.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1147.5,255l-0.8-1.4l-0.2-2.9l0.7-1.5l0.8,1.4l0.2,2.9L1147.5,255z M1146.9,253.1l0.6,0.9l0.4-1l-0.1-2 l-0.6-0.9l-0.4,1L1146.9,253.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1142.7,259l-0.8-1.4l-0.2-2.9l0.6-1.5l0.8,1.4l0.2,2.9L1142.7,259z M1142.1,257.1l0.6,0.9l0.4-1l-0.1-2 l-0.6-0.9l-0.4,1L1142.1,257.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1145.5,269.8l-0.7-1.2l-0.2-2.5l0.6-1.3l0.7,1.2l0.1,2.5L1145.5,269.8z M1145,268.1l0.4,0.7l0.3-0.8 l-0.1-1.5l-0.4-0.7l-0.3,0.8L1145,268.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1147.8,273.8l-0.7-1.2l-0.1-2.5l0.6-1.3l0.7,1.2l0.1,2.5L1147.8,273.8z M1147.3,272.1l0.4,0.7l0.3-0.8 l-0.1-1.5l-0.4-0.7l-0.3,0.8L1147.3,272.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1152.2,283.2l0.7-6.5l1.3,2.2l-0.1,0.9l-1-1.6l-0.2,2l0.9,1.5l-0.1,0.8l-0.9-1.5l-0.3,2.7L1152.2,283.2z  M1153.9,286.1l0.7-6.4l1.3,2.2l-0.1,0.9l-1-1.7l-0.2,1.9l0.9,1.6l-0.1,0.8l-0.9-1.6l-0.2,2l1,1.7l-0.1,0.9L1153.9,286.1z  M1155.7,289.1l0.7-6.4l1.3,2.2l-0.1,0.9l-1-1.7l-0.2,1.9l0.9,1.6l-0.1,0.8l-0.9-1.6l-0.2,2l1,1.7l-0.1,0.9L1155.7,289.1z  M1157.5,292l0.7-6.4l0.7,1.2c0.6,1,0.8,2.8,0.6,4.8l0,0c-0.2,2-0.7,2.6-1.3,1.6L1157.5,292z M1157.9,291.7l0.4,0.7 c0.4,0.7,0.8,0.3,0.9-1.2l0,0c0.2-1.5,0-2.8-0.4-3.5l-0.4-0.7L1157.9,291.7z M1160.3,297c-0.5-0.8-0.7-2-0.6-3.1l0-0.1l0.3,0.5 l0,0.1c0,0.6,0.1,1.3,0.4,1.8c0.3,0.4,0.5,0.3,0.6-0.3l0,0c0.1-0.5,0-1-0.3-1.6l-0.2-0.5c-0.4-1-0.5-1.9-0.4-2.8l0,0 c0.1-1.1,0.5-1.4,1-0.6c0.4,0.7,0.6,2,0.6,3l0,0.1l-0.3-0.5l0-0.1c0-0.6-0.1-1.2-0.3-1.6c-0.2-0.4-0.5-0.4-0.5,0.3l0,0 c-0.1,0.5,0,1,0.3,1.6l0.2,0.5c0.4,1,0.5,1.9,0.4,2.8l0,0C1161.2,297.5,1160.8,297.8,1160.3,297z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1154.4,275.5c-0.8-1.4-1.2-4.2-0.8-7.2l0,0c0.3-3,1.1-4,1.9-2.6c0.7,1.1,1,3.2,0.9,5.1l0,0.1l-0.5-0.8l0-0.1 c0-1.3-0.2-2.4-0.6-3.1c-0.6-0.9-1.1-0.1-1.3,2.1l0,0c-0.2,2.2,0,4.2,0.5,5.1c0.5,0.8,0.9,0.4,1.1-1l0-0.2l-0.8-1.3l0.1-1.2 l1.2,2.1l-0.1,1.2C1155.9,276.1,1155.2,276.8,1154.4,275.5z M1156.4,278.5l1-9.3l1.9,3.2l-0.1,1.2l-1.4-2.4l-0.3,2.7l1.3,2.3 l-0.1,1.2l-1.3-2.3l-0.3,2.9l1.4,2.4l-0.1,1.2L1156.4,278.5z M1158.9,282.8l1-9.3l0.4,0.7l0.8,9.3l0,0.1l0.7-6.8l0.4,0.8l-1,9.3 l-0.4-0.7l-0.8-9.3l0-0.1l-0.7,6.8L1158.9,282.8z M1162.1,288.1l1-9.3l0.5,0.8l-1,9.3L1162.1,288.1z M1164.5,292.3 c-0.7-1.2-1-3.4-0.8-5.4l0.7-6.1l0.5,0.8l-0.7,6c-0.1,1.3,0,2.7,0.5,3.5c0.5,0.8,0.8,0.3,1-1l0.7-6l0.5,0.8l-0.7,6.1 C1165.8,293,1165.2,293.6,1164.5,292.3z M1167.4,297.3c-0.7-1.1-1-2.9-0.8-4.5l0-0.1l0.5,0.8l0,0.1c-0.1,0.9,0.2,1.9,0.6,2.6 c0.4,0.6,0.7,0.5,0.8-0.4l0,0c0.1-0.7,0-1.4-0.4-2.4l-0.3-0.8c-0.6-1.4-0.7-2.7-0.6-4.1l0,0c0.2-1.6,0.7-2,1.4-0.9 c0.6,1.1,0.9,2.9,0.8,4.4l0,0.1l-0.4-0.7l0-0.1c0-0.8-0.1-1.8-0.5-2.4c-0.3-0.6-0.7-0.5-0.8,0.4l0,0c-0.1,0.7,0,1.4,0.4,2.3 l0.3,0.8c0.6,1.5,0.7,2.7,0.6,4l0,0C1168.6,298.1,1168.1,298.4,1167.4,297.3z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1013.8,52.6l0.5,0.9l0.1,1.9l-0.4,1l-0.5-0.9l-0.1-1.9L1013.8,52.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1014.1,56.5l-0.6-1l-0.1-2.1l0.5-1.1l0.6,1l0.1,2.1L1014.1,56.5z M1013.6,55.3l0.5,0.8l0.4-0.8l-0.1-1.6 l-0.5-0.8l-0.4,0.8L1013.6,55.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1017.5,71l0.5,0.9l0.1,1.8l-0.4,1l-0.5-0.9l-0.1-1.8L1017.5,71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1017.8,74.9l-0.6-1l-0.1-2.1l0.5-1.1l0.6,1l0.1,2.1L1017.8,74.9z M1017.3,73.6l0.5,0.8l0.4-0.8L1018,72 l-0.5-0.8l-0.4,0.8L1017.3,73.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1018.9,74.8l0.4,0.7l0.1,1.4l-0.3,0.7l-0.4-0.7l-0.1-1.4L1018.9,74.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1019,77.9l-0.5-0.8l-0.1-1.7l0.4-0.9l0.5,0.8l0.1,1.7L1019,77.9z M1018.7,76.9l0.3,0.6l0.3-0.6l-0.1-1.2 l-0.3-0.6l-0.3,0.6L1018.7,76.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1018.8,57l0.4,0.7l0.1,1.4l-0.3,0.8l-0.4-0.7l-0.1-1.4L1018.8,57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1019,60.1l-0.5-0.8l-0.1-1.7l0.4-0.9l0.5,0.8l0.1,1.7L1019,60.1z M1018.6,59.1l0.3,0.6l0.3-0.6l-0.1-1.2 l-0.3-0.6l-0.3,0.6L1018.6,59.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1018.6,47.5l0.4,0.7l0.1,1.4l-0.3,0.8l-0.4-0.7l-0.1-1.4L1018.6,47.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1018.8,50.6l-0.5-0.8l-0.1-1.7l0.4-0.9l0.5,0.8l0.1,1.7L1018.8,50.6z M1018.4,49.5l0.3,0.6l0.3-0.6l-0.1-1.2 l-0.3-0.6l-0.3,0.6L1018.4,49.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1014.1,58.6l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1014.1,58.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1014.2,60.4l-0.3-0.5l-0.1-1l0.2-0.6l0.3,0.5l0.1,1L1014.2,60.4z M1014,59.7l0.2,0.3l0.1-0.3l0-0.6l-0.2-0.3 l-0.1,0.3L1014,59.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1013.8,62.8l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1013.8,62.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1013.9,64.7l-0.3-0.5l-0.1-1l0.2-0.5l0.3,0.5l0.1,1L1013.9,64.7z M1013.7,63.9l0.2,0.3l0.1-0.3l0-0.6 l-0.2-0.3l-0.1,0.3L1013.7,63.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1016.4,62.9l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1016.4,62.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1016.5,64.7l-0.3-0.5l-0.1-1l0.2-0.5l0.3,0.5l0.1,1L1016.5,64.7z M1016.4,64l0.2,0.3l0.1-0.3l0-0.6l-0.2-0.3 l-0.1,0.3L1016.4,64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1017.8,62.6l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1017.8,62.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1018,64.5l-0.3-0.5l-0.1-1l0.2-0.5l0.3,0.5l0.1,1L1018,64.5z M1017.8,63.7l0.2,0.3l0.1-0.3l0-0.6l-0.2-0.3 l-0.1,0.3L1017.8,63.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1018.7,62.4l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1018.7,62.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1018.8,64.2l-0.3-0.5l-0.1-1l0.2-0.5l0.3,0.5l0.1,1L1018.8,64.2z M1018.6,63.5l0.2,0.3l0.1-0.3l0-0.6 l-0.2-0.3l-0.1,0.3L1018.6,63.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1018.8,66.8l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1018.8,66.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1018.9,68.7l-0.3-0.5l-0.1-1l0.2-0.5l0.3,0.5l0.1,1L1018.9,68.7z M1018.7,67.9l0.2,0.3l0.1-0.3l0-0.6 l-0.2-0.3l-0.1,0.3L1018.7,67.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1018.5,70.3l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1018.5,70.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1018.7,72.2l-0.3-0.5l-0.1-1l0.2-0.5l0.3,0.5l0.1,1L1018.7,72.2z M1018.5,71.4l0.2,0.3l0.1-0.3l0-0.6 l-0.2-0.3l-0.1,0.3L1018.5,71.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1017.9,76.2l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1017.9,76.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1018,78l-0.3-0.5l-0.1-1l0.2-0.5l0.3,0.5l0.1,1L1018,78z M1017.8,77.3l0.2,0.3l0.1-0.3l0-0.6l-0.2-0.3 l-0.1,0.3L1017.8,77.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1016.3,69.5l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1016.3,69.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1016.4,71.4l-0.3-0.5l-0.1-1l0.2-0.5l0.3,0.5l0.1,1L1016.4,71.4z M1016.2,70.6l0.2,0.3l0.1-0.3l0-0.6 l-0.2-0.3l-0.1,0.3L1016.2,70.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1016.1,66.2l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1016.1,66.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1016.2,68l-0.3-0.5l-0.1-1l0.2-0.5l0.3,0.5l0.1,1L1016.2,68z M1016,67.3l0.2,0.3l0.1-0.3l0-0.6l-0.2-0.3 l-0.1,0.3L1016,67.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1015.8,49.6l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1015.8,49.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1015.9,51.4l-0.3-0.5l-0.1-1l0.2-0.6l0.3,0.5l0.1,1L1015.9,51.4z M1015.7,50.7l0.2,0.3l0.1-0.3l0-0.6 l-0.2-0.3l-0.1,0.3L1015.7,50.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1015.6,45.8l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1015.6,45.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1015.7,47.7l-0.3-0.5l-0.1-1l0.2-0.6l0.3,0.5l0.1,1L1015.7,47.7z M1015.5,46.9l0.2,0.3l0.1-0.3l0-0.6 l-0.2-0.3l-0.1,0.3L1015.5,46.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1022.7,58.2l0.1,0.2l0,0.6l-0.1,0.3l-0.1-0.2l0-0.6L1022.7,58.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1022.7,59.5l-0.2-0.3l0-0.8l0.2-0.5l0.2,0.3l0,0.8L1022.7,59.5z M1022.7,59L1022.7,59l0.1-0.2l0-0.3l0,0 l-0.1,0.2L1022.7,59z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1021,57.4l0.1,0.2l0,0.6l-0.1,0.3l-0.1-0.2l0-0.6L1021,57.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1021,58.8l-0.2-0.3l0-0.8l0.2-0.5l0.2,0.3l0,0.8L1021,58.8z M1020.9,58.2L1020.9,58.2l0.1-0.2l0-0.3l0,0 l-0.1,0.2L1020.9,58.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1018,52.5l0.1,0.2l0,0.6l-0.1,0.3l-0.1-0.2l0-0.6L1018,52.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1018.1,53.8l-0.2-0.3l0-0.8l0.2-0.5l0.2,0.3l0,0.8L1018.1,53.8z M1018,53.3L1018,53.3l0.1-0.2l0-0.3l0,0 L1018,53L1018,53.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1021.2,69.5l0.1,0.2l0,0.6l-0.1,0.3l-0.1-0.2l0-0.6L1021.2,69.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1021.2,70.9l-0.2-0.3l0-0.8l0.2-0.5l0.2,0.3l0,0.8L1021.2,70.9z M1021.2,70.3L1021.2,70.3l0.1-0.2l0-0.3l0,0 l-0.1,0.2L1021.2,70.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1018.6,78.6l0.1,0.2l0,0.6l-0.1,0.3l-0.1-0.2l0-0.6L1018.6,78.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1018.6,79.9l-0.2-0.3l0-0.8l0.2-0.5l0.2,0.3l0,0.8L1018.6,79.9z M1018.5,79.3L1018.5,79.3l0.1-0.2l0-0.3l0,0 l-0.1,0.2L1018.5,79.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1011.2,58.3l0.1,0.2l0,0.6l-0.1,0.3l-0.1-0.2l0-0.6L1011.2,58.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1011.2,59.7l-0.2-0.3l0-0.8l0.2-0.5l0.2,0.3l0,0.8L1011.2,59.7z M1011.1,59.1L1011.1,59.1l0.1-0.2l0-0.3l0,0 l-0.1,0.2L1011.1,59.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1017.1,62.8l-1.6-2.8l-0.4-5.7l1.3-2.9l1.6,2.8l0.4,5.7L1017.1,62.8z M1015.7,59.3l1.2,2.1l1-2.2l-0.3-4.2 l-1.2-2.1l-1,2.2L1015.7,59.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1020.9,68.9l-1.5-2.6l-0.3-5.3l1.2-2.7l1.5,2.6l0.3,5.3L1020.9,68.9z M1019.7,65.5l1.1,1.9l0.9-1.9l-0.2-3.8 l-1.1-1.9l-0.9,2L1019.7,65.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1012.7,63.6l-1.1-1.8l-0.2-3.8l0.8-2l1.1,1.8l0.2,3.8L1012.7,63.6z M1011.9,61.3l0.8,1.3l0.6-1.5l-0.2-2.8 l-0.8-1.3l-0.6,1.5L1011.9,61.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1014.5,52.6l-1.1-1.8l-0.2-3.8l0.8-2l1.1,1.8l0.2,3.8L1014.5,52.6z M1013.6,50.3l0.8,1.3l0.6-1.5l-0.2-2.8 l-0.8-1.3l-0.6,1.5L1013.6,50.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1019.9,57.8l-1.1-1.8l-0.2-3.8l0.8-2l1.1,1.8l0.2,3.8L1019.9,57.8z M1019,55.5l0.8,1.3l0.6-1.5l-0.2-2.8 l-0.8-1.3l-0.6,1.5L1019,55.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1020.3,74.7l-0.8-1.4l-0.2-2.9l0.6-1.5l0.8,1.4l0.2,2.9L1020.3,74.7z M1019.7,72.8l0.6,0.9l0.4-1l-0.1-2 l-0.6-0.9l-0.4,1L1019.7,72.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1017.4,51.5l-0.8-1.4l-0.2-2.9l0.7-1.5l0.8,1.4l0.2,2.9L1017.4,51.5z M1016.8,49.6l0.6,0.9l0.4-1l-0.1-2 l-0.6-0.9l-0.4,1L1016.8,49.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1012.5,55.5l-0.8-1.4l-0.2-2.9l0.6-1.5l0.8,1.4l0.2,2.9L1012.5,55.5z M1011.9,53.6l0.6,0.9l0.4-1l-0.1-2 l-0.6-0.9l-0.4,1L1011.9,53.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1015.3,66.3l-0.7-1.2l-0.2-2.5l0.6-1.3l0.7,1.2l0.1,2.5L1015.3,66.3z M1014.8,64.6l0.4,0.7l0.3-0.8l-0.1-1.5 l-0.4-0.7l-0.3,0.8L1014.8,64.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1017.6,70.3l-0.7-1.2l-0.1-2.5l0.6-1.3l0.7,1.2l0.1,2.5L1017.6,70.3z M1017.2,68.6l0.4,0.7l0.3-0.8l-0.1-1.5 l-0.4-0.7l-0.3,0.8L1017.2,68.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1022.1,79.7l0.7-6.5l1.3,2.2l-0.1,0.9l-1-1.6l-0.2,2l0.9,1.5l-0.1,0.8l-0.9-1.5l-0.3,2.7L1022.1,79.7z  M1023.8,82.6l0.7-6.4l1.3,2.2l-0.1,0.9l-1-1.7l-0.2,1.9l0.9,1.6l-0.1,0.8l-0.9-1.6l-0.2,2l1,1.7l-0.1,0.9L1023.8,82.6z  M1025.5,85.6l0.7-6.4l1.3,2.2l-0.1,0.9l-1-1.7l-0.2,1.9l0.9,1.6l-0.1,0.8l-0.9-1.6l-0.2,2l1,1.7l-0.1,0.9L1025.5,85.6z  M1027.3,88.5l0.7-6.4l0.7,1.2c0.6,1,0.8,2.8,0.6,4.8l0,0c-0.2,2-0.7,2.6-1.3,1.6L1027.3,88.5z M1027.7,88.2l0.4,0.7 c0.4,0.7,0.8,0.3,0.9-1.2l0,0c0.2-1.5,0-2.8-0.4-3.5l-0.4-0.7L1027.7,88.2z M1030.1,93.5c-0.5-0.8-0.7-2-0.6-3.1l0-0.1l0.3,0.5 l0,0.1c0,0.6,0.1,1.3,0.4,1.8c0.3,0.4,0.5,0.3,0.6-0.3l0,0c0.1-0.5,0-1-0.3-1.6l-0.2-0.5c-0.4-1-0.5-1.9-0.4-2.8l0,0 c0.1-1.1,0.5-1.4,1-0.6c0.4,0.7,0.6,2,0.6,3l0,0.1l-0.3-0.5l0-0.1c0-0.6-0.1-1.2-0.3-1.6c-0.2-0.4-0.5-0.4-0.5,0.3l0,0 c-0.1,0.5,0,1,0.3,1.6l0.2,0.5c0.4,1,0.5,1.9,0.4,2.8l0,0C1031,94,1030.6,94.3,1030.1,93.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1024.2,72c-0.8-1.4-1.2-4.2-0.8-7.2l0,0c0.3-3,1.1-4,1.9-2.6c0.7,1.1,1,3.2,0.9,5.1l0,0.1l-0.5-0.8l0-0.1 c0-1.3-0.2-2.4-0.6-3.1c-0.6-0.9-1.1-0.1-1.3,2.1l0,0c-0.2,2.2,0,4.2,0.5,5.1c0.5,0.8,0.9,0.4,1.1-1l0-0.2l-0.8-1.3l0.1-1.2 l1.2,2.1l-0.1,1.2C1025.7,72.6,1025,73.3,1024.2,72z M1026.2,75l1-9.3l1.9,3.2l-0.1,1.2l-1.4-2.4l-0.3,2.7l1.3,2.3l-0.1,1.2 l-1.3-2.3l-0.3,2.9l1.4,2.4l-0.1,1.2L1026.2,75z M1028.7,79.3l1-9.3l0.4,0.7l0.8,9.3l0,0.1l0.7-6.8l0.4,0.8l-1,9.3l-0.4-0.7 l-0.8-9.3l0-0.1l-0.7,6.8L1028.7,79.3z M1031.9,84.6l1-9.3l0.5,0.8l-1,9.3L1031.9,84.6z M1034.3,88.8c-0.7-1.2-1-3.4-0.8-5.4 l0.7-6.1l0.5,0.8l-0.7,6c-0.1,1.3,0,2.7,0.5,3.5c0.5,0.8,0.8,0.3,1-1l0.7-6l0.5,0.8l-0.7,6.1C1035.6,89.5,1035,90.1,1034.3,88.8z  M1037.2,93.8c-0.7-1.1-1-2.9-0.8-4.5l0-0.1l0.5,0.8l0,0.1c-0.1,0.9,0.2,1.9,0.6,2.6c0.4,0.6,0.7,0.5,0.8-0.4l0,0 c0.1-0.7,0-1.4-0.4-2.4l-0.3-0.8c-0.6-1.4-0.7-2.7-0.6-4.1l0,0c0.2-1.6,0.7-2,1.4-0.9c0.6,1.1,0.9,2.9,0.8,4.4l0,0.1l-0.4-0.7 l0-0.1c0-0.8-0.1-1.8-0.5-2.4c-0.3-0.6-0.7-0.5-0.8,0.4l0,0c-0.1,0.7,0,1.4,0.4,2.3l0.3,0.8c0.6,1.5,0.7,2.7,0.6,4l0,0 C1038.5,94.6,1037.9,94.9,1037.2,93.8z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1075.9,148.3l0.5,0.9l0.1,1.9l-0.4,1l-0.5-0.9l-0.1-1.9L1075.9,148.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1076.2,152.2l-0.6-1l-0.1-2.1l0.5-1.1l0.6,1l0.1,2.1L1076.2,152.2z M1075.7,151l0.5,0.8l0.4-0.8l-0.1-1.6 l-0.5-0.8l-0.4,0.8L1075.7,151z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1079.7,166.7l0.5,0.9l0.1,1.8l-0.4,1l-0.5-0.9l-0.1-1.8L1079.7,166.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1079.9,170.6l-0.6-1l-0.1-2.1l0.5-1.1l0.6,1l0.1,2.1L1079.9,170.6z M1079.4,169.4l0.5,0.8l0.4-0.8l-0.1-1.6 l-0.5-0.8l-0.4,0.8L1079.4,169.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1081,170.6l0.4,0.7l0.1,1.4l-0.3,0.7l-0.4-0.7l-0.1-1.4L1081,170.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1081.2,173.6l-0.5-0.8l-0.1-1.7l0.4-0.9l0.5,0.8l0.1,1.7L1081.2,173.6z M1080.8,172.6l0.3,0.6l0.3-0.6 l-0.1-1.2l-0.3-0.6l-0.3,0.6L1080.8,172.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1080.9,152.7l0.4,0.7l0.1,1.4l-0.3,0.8l-0.4-0.7l-0.1-1.4L1080.9,152.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1081.1,155.8l-0.5-0.8l-0.1-1.7l0.4-0.9l0.5,0.8l0.1,1.7L1081.1,155.8z M1080.8,154.8l0.3,0.6l0.3-0.6 l-0.1-1.2l-0.3-0.6l-0.3,0.6L1080.8,154.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1080.7,143.2l0.4,0.7l0.1,1.4l-0.3,0.8l-0.4-0.7l-0.1-1.4L1080.7,143.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1080.9,146.3l-0.5-0.8l-0.1-1.7l0.4-0.9l0.5,0.8l0.1,1.7L1080.9,146.3z M1080.5,145.2l0.3,0.6l0.3-0.6 l-0.1-1.2l-0.3-0.6l-0.3,0.6L1080.5,145.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1076.2,154.3l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1076.2,154.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1076.3,156.1l-0.3-0.5l-0.1-1l0.2-0.6l0.3,0.5l0.1,1L1076.3,156.1z M1076.1,155.4l0.2,0.3l0.1-0.3l0-0.6 l-0.2-0.3l-0.1,0.3L1076.1,155.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1075.9,158.5l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1075.9,158.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1076,160.4l-0.3-0.5l-0.1-1l0.2-0.5l0.3,0.5l0.1,1L1076,160.4z M1075.8,159.6l0.2,0.3l0.1-0.3l0-0.6 l-0.2-0.3l-0.1,0.3L1075.8,159.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1078.5,158.6l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1078.5,158.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1078.7,160.4l-0.3-0.5l-0.1-1l0.2-0.5l0.3,0.5l0.1,1L1078.7,160.4z M1078.5,159.7l0.2,0.3l0.1-0.3l0-0.6 l-0.2-0.3l-0.1,0.3L1078.5,159.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1080,158.4l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1080,158.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1080.1,160.2l-0.3-0.5l-0.1-1l0.2-0.5l0.3,0.5l0.1,1L1080.1,160.2z M1079.9,159.5l0.2,0.3l0.1-0.3l0-0.6 l-0.2-0.3l-0.1,0.3L1079.9,159.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1080.8,158.1l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1080.8,158.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1080.9,159.9l-0.3-0.5l-0.1-1l0.2-0.5l0.3,0.5l0.1,1L1080.9,159.9z M1080.7,159.2l0.2,0.3l0.1-0.3l0-0.6 l-0.2-0.3l-0.1,0.3L1080.7,159.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1080.9,162.5l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1080.9,162.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1081,164.4l-0.3-0.5l-0.1-1l0.2-0.5l0.3,0.5l0.1,1L1081,164.4z M1080.8,163.6l0.2,0.3l0.1-0.3l0-0.6 l-0.2-0.3l-0.1,0.3L1080.8,163.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1080.7,166l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1080.7,166z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1080.8,167.9l-0.3-0.5l-0.1-1l0.2-0.5l0.3,0.5l0.1,1L1080.8,167.9z M1080.6,167.1l0.2,0.3l0.1-0.3l0-0.6 l-0.2-0.3l-0.1,0.3L1080.6,167.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1080,171.9l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1080,171.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1080.1,173.8l-0.3-0.5l-0.1-1l0.2-0.5l0.3,0.5l0.1,1L1080.1,173.8z M1080,173l0.2,0.3l0.1-0.3l0-0.6 l-0.2-0.3l-0.1,0.3L1080,173z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1078.4,165.3l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1078.4,165.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1078.5,167.1l-0.3-0.5l-0.1-1l0.2-0.5l0.3,0.5l0.1,1L1078.5,167.1z M1078.3,166.4l0.2,0.3l0.1-0.3l0-0.6 l-0.2-0.3l-0.1,0.3L1078.3,166.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1078.2,161.9l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1078.2,161.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1078.3,163.7l-0.3-0.5l-0.1-1l0.2-0.5l0.3,0.5l0.1,1L1078.3,163.7z M1078.1,163l0.2,0.3l0.1-0.3l0-0.6 l-0.2-0.3l-0.1,0.3L1078.1,163z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1077.9,145.3l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1077.9,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1078,147.2l-0.3-0.5l-0.1-1l0.2-0.6l0.3,0.5l0.1,1L1078,147.2z M1077.8,146.4l0.2,0.3l0.1-0.3l0-0.6 l-0.2-0.3l-0.1,0.3L1077.8,146.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1077.7,141.6l0.2,0.4l0,0.8l-0.2,0.4l-0.2-0.4l0-0.8L1077.7,141.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1077.8,143.4l-0.3-0.5l-0.1-1l0.2-0.6l0.3,0.5l0.1,1L1077.8,143.4z M1077.6,142.7l0.2,0.3l0.1-0.3l0-0.6 l-0.2-0.3l-0.1,0.3L1077.6,142.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1084.8,153.9l0.1,0.2l0,0.6l-0.1,0.3l-0.1-0.2l0-0.6L1084.8,153.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1084.8,155.2l-0.2-0.3l0-0.8l0.2-0.5l0.2,0.3l0,0.8L1084.8,155.2z M1084.8,154.7L1084.8,154.7l0.1-0.2l0-0.3 l0,0l-0.1,0.2L1084.8,154.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1083.1,153.2l0.1,0.2l0,0.6l-0.1,0.3l-0.1-0.2l0-0.6L1083.1,153.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1083.1,154.5l-0.2-0.3l0-0.8l0.2-0.5l0.2,0.3l0,0.8L1083.1,154.5z M1083,154L1083,154l0.1-0.2l0-0.3l0,0 l-0.1,0.2L1083,154z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1080.1,148.2l0.1,0.2l0,0.6l-0.1,0.3l-0.1-0.2l0-0.6L1080.1,148.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1080.2,149.5l-0.2-0.3l0-0.8l0.2-0.5l0.2,0.3l0,0.8L1080.2,149.5z M1080.1,149L1080.1,149l0.1-0.2l0-0.3l0,0 l-0.1,0.2L1080.1,149z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1083.3,165.3l0.1,0.2l0,0.6l-0.1,0.3l-0.1-0.2l0-0.6L1083.3,165.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1083.3,166.6l-0.2-0.3l0-0.8l0.2-0.5l0.2,0.3l0,0.8L1083.3,166.6z M1083.3,166.1L1083.3,166.1l0.1-0.2l0-0.3 l0,0l-0.1,0.2L1083.3,166.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1080.7,174.3l0.1,0.2l0,0.6l-0.1,0.3l-0.1-0.2l0-0.6L1080.7,174.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1080.7,175.6l-0.2-0.3l0-0.8l0.2-0.5l0.2,0.3l0,0.8L1080.7,175.6z M1080.6,175.1L1080.6,175.1l0.1-0.2l0-0.3 l0,0l-0.1,0.2L1080.6,175.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1073.3,154.1l0.1,0.2l0,0.6l-0.1,0.3l-0.1-0.2l0-0.6L1073.3,154.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1073.3,155.4l-0.2-0.3l0-0.8l0.2-0.5l0.2,0.3l0,0.8L1073.3,155.4z M1073.2,154.9L1073.2,154.9l0.1-0.2l0-0.3 l0,0l-0.1,0.2L1073.2,154.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1079.2,158.5l-1.6-2.8l-0.4-5.7l1.3-2.9l1.6,2.8l0.4,5.7L1079.2,158.5z M1077.8,155l1.2,2.1l1-2.2l-0.3-4.2 l-1.2-2.1l-1,2.2L1077.8,155z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1083,164.6l-1.5-2.6l-0.3-5.3l1.2-2.7l1.5,2.6l0.3,5.3L1083,164.6z M1081.8,161.3l1.1,1.9l0.9-1.9l-0.2-3.8 l-1.1-1.9l-0.9,2L1081.8,161.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1074.9,159.3l-1.1-1.8l-0.2-3.8l0.8-2l1.1,1.8l0.2,3.8L1074.9,159.3z M1074,157l0.8,1.3l0.6-1.5l-0.2-2.8 l-0.8-1.3l-0.6,1.5L1074,157z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1076.6,148.3l-1.1-1.8l-0.2-3.8l0.8-2l1.1,1.8l0.2,3.8L1076.6,148.3z M1075.7,146l0.8,1.3l0.6-1.5l-0.2-2.8 l-0.8-1.3l-0.6,1.5L1075.7,146z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1082,153.5l-1.1-1.8l-0.2-3.8l0.8-2l1.1,1.8l0.2,3.8L1082,153.5z M1081.1,151.2l0.8,1.3l0.6-1.5l-0.2-2.8 l-0.8-1.3l-0.6,1.5L1081.1,151.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1082.4,170.4l-0.8-1.4l-0.2-2.9l0.6-1.5l0.8,1.4l0.2,2.9L1082.4,170.4z M1081.8,168.5l0.6,0.9l0.4-1l-0.1-2 l-0.6-0.9l-0.4,1L1081.8,168.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1079.5,147.2l-0.8-1.4l-0.2-2.9l0.7-1.5l0.8,1.4l0.2,2.9L1079.5,147.2z M1078.9,145.3l0.6,0.9l0.4-1l-0.1-2 l-0.6-0.9l-0.4,1L1078.9,145.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1074.6,151.2l-0.8-1.4l-0.2-2.9l0.6-1.5l0.8,1.4l0.2,2.9L1074.6,151.2z M1074,149.3l0.6,0.9l0.4-1l-0.1-2 l-0.6-0.9l-0.4,1L1074,149.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1077.4,162l-0.7-1.2l-0.2-2.5l0.6-1.3l0.7,1.2l0.1,2.5L1077.4,162z M1076.9,160.4l0.4,0.7l0.3-0.8l-0.1-1.5 l-0.4-0.7l-0.3,0.8L1076.9,160.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1079.8,166l-0.7-1.2l-0.1-2.5l0.6-1.3l0.7,1.2l0.1,2.5L1079.8,166z M1079.3,164.3l0.4,0.7l0.3-0.8l-0.1-1.5 l-0.4-0.7l-0.3,0.8L1079.3,164.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1084.2,175.5l0.7-6.5l1.3,2.2l-0.1,0.9l-1-1.6l-0.2,2l0.9,1.5l-0.1,0.8l-0.9-1.5l-0.3,2.7L1084.2,175.5z  M1085.9,178.3l0.7-6.4l1.3,2.2l-0.1,0.9l-1-1.7l-0.2,1.9l0.9,1.6l-0.1,0.8l-0.9-1.6l-0.2,2l1,1.7l-0.1,0.9L1085.9,178.3z  M1087.6,181.3l0.7-6.4l1.3,2.2l-0.1,0.9l-1-1.7l-0.2,1.9l0.9,1.6l-0.1,0.8l-0.9-1.6l-0.2,2l1,1.7l-0.1,0.9L1087.6,181.3z  M1089.4,184.3l0.7-6.4l0.7,1.2c0.6,1,0.8,2.8,0.6,4.8l0,0c-0.2,2-0.7,2.6-1.3,1.6L1089.4,184.3z M1089.8,183.9l0.4,0.7 c0.4,0.7,0.8,0.3,0.9-1.2l0,0c0.2-1.5,0-2.8-0.4-3.5l-0.4-0.7L1089.8,183.9z M1092.2,189.2c-0.5-0.8-0.7-2-0.6-3.1l0-0.1l0.3,0.5 l0,0.1c0,0.6,0.1,1.3,0.4,1.8c0.3,0.4,0.5,0.3,0.6-0.3l0,0c0.1-0.5,0-1-0.3-1.6l-0.2-0.5c-0.4-1-0.5-1.9-0.4-2.8l0,0 c0.1-1.1,0.5-1.4,1-0.6c0.4,0.7,0.6,2,0.6,3l0,0.1l-0.3-0.5l0-0.1c0-0.6-0.1-1.2-0.3-1.6c-0.2-0.4-0.5-0.4-0.5,0.3l0,0 c-0.1,0.5,0,1,0.3,1.6l0.2,0.5c0.4,1,0.5,1.9,0.4,2.8l0,0C1093.1,189.7,1092.7,190,1092.2,189.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1086.3,167.7c-0.8-1.4-1.2-4.2-0.8-7.2l0,0c0.3-3,1.1-4,1.9-2.6c0.7,1.1,1,3.2,0.9,5.1l0,0.1l-0.5-0.8l0-0.1 c0-1.3-0.2-2.4-0.6-3.1c-0.6-0.9-1.1-0.1-1.3,2.1l0,0c-0.2,2.2,0,4.2,0.5,5.1c0.5,0.8,0.9,0.4,1.1-1l0-0.2l-0.8-1.3l0.1-1.2 l1.2,2.1l-0.1,1.2C1087.8,168.3,1087.1,169,1086.3,167.7z M1088.3,170.7l1-9.3l1.9,3.2l-0.1,1.2l-1.4-2.4l-0.3,2.7l1.3,2.3 l-0.1,1.2l-1.3-2.3l-0.3,2.9l1.4,2.4l-0.1,1.2L1088.3,170.7z M1090.8,175l1-9.3l0.4,0.7l0.8,9.3l0,0.1l0.7-6.8l0.4,0.8l-1,9.3 l-0.4-0.7l-0.8-9.3l0-0.1l-0.7,6.8L1090.8,175z M1094,180.3l1-9.3l0.5,0.8l-1,9.3L1094,180.3z M1096.4,184.6 c-0.7-1.2-1-3.4-0.8-5.4l0.7-6.1l0.5,0.8l-0.7,6c-0.1,1.3,0,2.7,0.5,3.5c0.5,0.8,0.8,0.3,1-1l0.7-6l0.5,0.8l-0.7,6.1 C1097.7,185.2,1097.1,185.8,1096.4,184.6z M1099.3,189.5c-0.7-1.1-1-2.9-0.8-4.5l0-0.1l0.5,0.8l0,0.1c-0.1,0.9,0.2,1.9,0.6,2.6 c0.4,0.6,0.7,0.5,0.8-0.4l0,0c0.1-0.7,0-1.4-0.4-2.4l-0.3-0.8c-0.6-1.4-0.7-2.7-0.6-4.1l0,0c0.2-1.6,0.7-2,1.4-0.9 c0.6,1.1,0.9,2.9,0.8,4.4l0,0.1l-0.4-0.7l0-0.1c0-0.8-0.1-1.8-0.5-2.4c-0.3-0.6-0.7-0.5-0.8,0.4l0,0c-0.1,0.7,0,1.4,0.4,2.3 l0.3,0.8c0.6,1.5,0.7,2.7,0.6,4l0,0C1100.6,190.3,1100,190.6,1099.3,189.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdBanner);
export default __webpack_public_path__ + "static/media/ad-banner.acc1c6124492a8fae2113975a5c533bb.svg";
export { ForwardRef as ReactComponent };